import actionCreatorFactory from 'typescript-fsa';

import { FormName } from '@topconagriculture/feed-types';

import reduxConfig from '../../../store/config';
import { Group } from '../../entities/group/group.types';
import {
  DataTransferMethods,
  DraggableFeeding,
  FeedingGroupRow,
  FeedingInScheduling,
  LoadMixer,
  LoadMixerPremix,
  SchedulePremixPayload,
} from './loadMixers.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/loadMixers');

export const getFeedingLoads = actionCreator.async<{}, LoadMixer[]>('GET_FEEDING_LOADS');
export const addLoadMixer = actionCreator<number>('ADD_LOAD_MIXER');
export const deleteLoadMixer = actionCreator<number>('DELETE_LOAD_MIXER');
export const setDataTransferMethod = actionCreator<DataTransferMethods>('SET_DATA_TRANSFER_METHOD');
export const setEffectiveDate = actionCreator<Date>('SET_EFFECTIVE_DATE');

export const resetSelectedMixers = actionCreator('RESET_SELECTED_LOAD_MIXERS');
export const resetFeedingLoads = actionCreator('RESET_FEEDING_LOADS');
export const getLoadMixerPremixesList = actionCreator.async<{}, LoadMixerPremix>('GET_LOAD_MIXER_PREMIXES');
export const getAllFeedingPeriodDetail = actionCreator.async('GET_ALL_FEEDING_PERIOD_DETAIL');
export const setSelectedScheduledPremix = actionCreator<string | null>('SET_SELECTED_SCHEDULED_PREMIX');
export const deletePremixInFeeding = actionCreator.async<{}, Group>('DELETE_PREMIX_IN_FEEDING');
export const deleteRecipeInFeeding = actionCreator.async<{}, Group>('DELETE_RECIPE_IN_FEEDING');
export const sendFeedingLoadsToMixer = actionCreator.async<
  { channel: string; effectiveDate?: Date; formName: FormName },
  {}
>('SEND_FEEDING_LOADS_TO_MIXER');
export const updatePremixInFeeding = actionCreator.async<{}, Group>('UPDATE_PREMIX_IN_FEEDING');
export const resetLoadMixers = actionCreator('RESET_LOAD_MIXERS');
export const setFeedingsScheduling = actionCreator<FeedingInScheduling[]>('SET_FEEDINGS_SCHEDULING');
export const updateFeedingScheduling = actionCreator<FeedingInScheduling>('UPDATE_FEEDING_SCHEDULING');
export const resetFeedingsScheduling = actionCreator('RESET_FEEDINGS_SCHEDULING');
export const schedulePremix = actionCreator.async<SchedulePremixPayload, void>('SCHEDULE_PREMIX');
export const moveFeedingScheduling = actionCreator<{ oldFeedingPeriodId: string; feedingPeriodId: string }>(
  'MOVE_FEEDING_SCHEDULING',
);
export const addFeedingScheduling = actionCreator<FeedingInScheduling>('ADD_FEEDING_SCHEDULIGN');
export const removeFeedingScheduling = actionCreator<string>('REMOVE_FEEDING_SCHEDULIGN');
export const setActiveFeedingLoad = actionCreator<LoadMixer | null>('SET_ACTIVE_FEEDING_LOAD');
export const setActiveFeedingLoadGroup = actionCreator<FeedingGroupRow | null>('SET_ACTIVE_FEEDING_LOAD_GROUP');
export const setActiveFeedingGroup = actionCreator<FeedingGroupRow | null>('SET_ACTIVE_FEEDING_GROUP');
export const setActiveDraggingFeedingGroup = actionCreator<DraggableFeeding | null>(
  'SET_ACTIVE_DRAGGING_FEEDING_GROUP',
);
export const setAutoExpandLoad = actionCreator<boolean>('SET_AUTO_EXPAND');
